// START IMPORTS
import { useTheme } from '@ltvco/refresh-lib/theme';
import { Owner } from '@ltvco/refresh-lib/v1';
import { useFeatureIsOn, useFeatureValue } from '@ltvco/refresh-lib/vendors';
import { Share, Person2, Phone, Work, TaskAlt } from '@mui/icons-material';
// END IMPORTS

// START HELPER_FUNCTIONS
export const getSocialNavLinkData = (
  owner: Owner,
  potentialOwnersLength: number
) => {
  const theme = useTheme();
  const isUsernamePartialAddress = useFeatureIsOn('OAR-1706');
  const isInPotentialOwnerVariation = useFeatureValue('RFRSH-3948', '');
  const isInPotentialOwnersVariation1 =
    isInPotentialOwnerVariation === 'RFRSH-3948_variation_1';

  let potentialOwnerNumbers = 0;

  if (potentialOwnersLength > 0) {
    potentialOwnerNumbers = isInPotentialOwnersVariation1
      ? 1
      : potentialOwnersLength;
  }

  return [
    {
      href: '#username-overview',
      labelText: 'Overview',
      icons: [
        <Share
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'username-overview',
    },
    {
      labelText: 'Potential Owners',
      icons: [
        <Person2
          sx={{ color: theme.palette.primary.main, fontSize: '1.4rem' }}
        />,
      ],
      name: 'potential-owners-section',
      childItems: [
        {
          href: '#potential-owners-section',
          labelText: 'Potential Owners',
          reportItemsCount: potentialOwnerNumbers,
          name: 'potential-owners-section',
        },
        ...(isInPotentialOwnersVariation1 && potentialOwnersLength > 1
          ? [
              {
                labelText: 'Others Associated',
                href: '#others-associated-section',
                name: 'others-associated-section',
                notificationSection: 'others-associated-section',
                reportItemsCount: Math.max(potentialOwnersLength - 1, 0),
              },
            ]
          : []),
        {
          href: '#possible-photos-section',
          labelText: 'Possible Photos',
          reportItemsCount: owner.images?.length || null,
          name: 'possible-photos-section',
        },
      ],
    },
    {
      labelText: 'Contact Information',
      name: 'contact-information-section',
      icons: [
        <Phone
          sx={{ color: theme.palette.primary.main, fontSize: '1.4rem' }}
        />,
      ],
      childItems: [
        {
          href: '#phone-numbers-section',
          labelText: 'Phone Numbers',
          reportItemsCount: Math.max(owner.phones.length - 1, 0),
          name: 'phone-numbers-section',
        },
        {
          href: '#email-section',
          labelText: 'Email Addresses',
          reportItemsCount: owner.emails.length,
          name: 'email-section',
        },
        {
          href: '#address-history-section',
          labelText: isUsernamePartialAddress
            ? 'Possible Locations'
            : 'Address History',
          reportItemsCount: owner.addresses.length,
          name: 'address-history-section',
        },
        {
          href: '#social-media-section',
          sectionId: '#social-media-section',
          labelText: 'Social Media',
          reportItemsCount: owner.profiles.length + owner.usernames.length,
          name: 'social-media-section',
        },
      ],
    },
    {
      labelText: 'Jobs & Education',
      name: 'jobs-educations-section',
      icons: [
        <Work sx={{ color: theme.palette.primary.main, fontSize: '1.4rem' }} />,
      ],
      childItems: [
        {
          href: '#jobs-section',
          sectionId: '#jobs-section',
          labelText: 'Jobs',
          reportItemsCount: owner.jobs.length,
          name: 'jobs-section',
        },
        {
          href: '#education-section',
          sectionId: '#education-section',
          labelText: 'Education',
          reportItemsCount: owner.educations.length,
          name: 'education-section',
        },
      ],
    },
    {
      labelText: 'Next Steps',
      name: 'next-steps-section',
      icons: [
        <TaskAlt
          sx={{ color: theme.palette.primary.main, fontSize: '1.4rem' }}
        />,
      ],
      childItems: [
        {
          href: '#attachments-section',
          labelText: 'Report attachments',
          hideReportItemsCount: true,
          name: 'attachments-section',
        },
        {
          href: '#Notes-section',
          labelText: 'Notes',
          hideReportItemsCount: true,
          name: 'notes-section',
        },
        {
          href: '#related-reports-section',
          labelText: 'Related Reports',
          hideReportItemsCount: true,
          name: 'related-reports-section',
        },
        {
          href: '#report-rating',
          labelText: 'Report Rating',
          hideReportItemsCount: true,
          name: 'report-rating',
        },
      ],
    },
  ];
};
// END HELPER_FUNCTIONS
